import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import formReducer from "./reducers/formReducer";
import formPromoterReducer from "./reducers/formPromoterReducer";
import sidebarReducer from "./reducers/sidebarReducer";
import authReducer from './reducers/authReducer';
import sectionReducer from "./reducers/sectionReducer";

const persistConfig = {
    key: "root",
    storage,
};

const rootReducer = combineReducers({
    formPromoter: formPromoterReducer,
    form: formReducer,
    sidebar: sidebarReducer,
    auth: authReducer,
    section: sectionReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
                ignoredActionPaths: ["register", "rehydrate"],
            },
        }),
});

export const persistor = persistStore(store);
